import { type ComponentProps, Suspense } from "solid-js";
import type { ListGroup, ListWithMeta } from "@listto/shared";
import { ListDialog } from "@/features/todos/components/list-dialog";
import { ShareListDialog } from "@/features/todos/components/share-list-dialog";
import { ChoiceDialog } from "@/features/todos/components/choice-dialog";
import { GroupDialog } from "@/features/todos/components/group-dialog";
import { ShortcutsModal } from "@/components/shortcuts-modal";

interface AppLayoutDialogsProps {
  listDialogOpen: () => boolean;
  setListDialogOpen: (open: boolean) => void;
  listDialogProps: () => ComponentProps<typeof ListDialog>["list"];
  creationGroupId: () => string | undefined;
  choiceDialogOpen: () => boolean;
  setChoiceDialogOpen: (open: boolean) => void;
  openNewListDialog: () => void;
  openNewGroupDialog: () => void;
  groupDialogOpen: () => boolean;
  setGroupDialogOpen: (open: boolean) => void;
  editingGroup: () => ListGroup | null | undefined;
  shareDialogOpen: () => boolean;
  setShareDialogOpen: (open: boolean) => void;
  selectedList: () => ListWithMeta | null | undefined;
  shortcutsOpen: () => boolean;
  setShortcutsOpen: (open: boolean) => void;
}

export function AppLayoutDialogs(props: AppLayoutDialogsProps) {
  return (
    <>
      <ListDialog
        open={props.listDialogOpen()}
        onOpenChange={(val) => {
          props.setListDialogOpen(val);
        }}
        list={props.listDialogProps()}
        groupId={props.creationGroupId() ?? undefined}
      />

      <ChoiceDialog
        open={props.choiceDialogOpen()}
        onOpenChange={(val) => {
          props.setChoiceDialogOpen(val);
        }}
        onCreateList={() => {
          props.openNewListDialog();
        }}
        onCreateGroup={() => {
          props.openNewGroupDialog();
        }}
        groupId={props.creationGroupId() ?? undefined}
      />

      <GroupDialog
        open={props.groupDialogOpen()}
        onOpenChange={(val) => {
          props.setGroupDialogOpen(val);
        }}
        group={props.editingGroup() ?? undefined}
      />

      <Suspense fallback={null}>
        <ShareListDialog
          open={props.shareDialogOpen()}
          onOpenChange={(val) => {
            props.setShareDialogOpen(val);
          }}
          listId={props.selectedList()?.id ?? ""}
          listName={props.selectedList()?.name ?? ""}
        />
      </Suspense>

      <ShortcutsModal
        isOpen={props.shortcutsOpen()}
        onClose={() => {
          props.setShortcutsOpen(false);
        }}
      />
    </>
  );
}
